import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

import MuiTable from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import Typography from "@material-ui/core/Typography"
import MuiLink from "@material-ui/core/Link"

import { useAdminState } from "../Context"
import AdminLoader from "components/partials/AdminLoader"
import AdminEmptyMessage from "components/partials/AdminEmptyMessage"
import AdminTableContainer from "components/partials/AdminTableContainer"
import AdminActionContainer from "components/partials/AdminActionContainer"
import AdminNavigation from "components/partials/AdminNavigation"
import MultiSelectActions from "./MultiSelectActions"
import Row from "./Row"
import Header from "./Header"
import Pagination from "./Pagination"

const Table = () => {
    return (
        <>
            <AdminNavigation />

            <AdminTableContainer>
                <MuiTable>
                    <Header />
                    <TableBody>
                        <Rows />
                    </TableBody>
                </MuiTable>
            </AdminTableContainer>

            <AdminActionContainer>
                <Pagination />
                <MultiSelectActions />
            </AdminActionContainer>
        </>
    )
}

const Rows = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const { rows, isLoading } = useAdminState()

    if (isLoading) {
        return <AdminLoader />
    }

    if (!rows.length) {
        return (
            <AdminEmptyMessage title={t("view.adminCompanies.modifyFilterTitle")}>
                <Typography>
                    {t("view.adminCompanies.modifyFilterMessage1")}&nbsp;
                    <MuiLink to={location.pathname} component={Link}>
                        {t("view.adminCompanies.modifyFilterMessage2")}
                    </MuiLink>
                    .
                </Typography>
            </AdminEmptyMessage>
        )
    }

    return (
        <>
            {rows.map(row => (
                <Row key={row.id} data={row} />
            ))}
        </>
    )
}

export default Table
